import axios from "axios";
import { Fragment, useEffect } from "react";
import { useState } from "react";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import "../Board/NoticeDetail.scss";
import "../CustomerBoard/CustomerqaDetail.scss";
import "../CompleteService/ReviewCompletionStatus.scss";
import Swal from "sweetalert2";
import jwtDecode from "jwt-decode";

export default function SuccessionDetail() {
  let navigate = useNavigate();
  const { state } = useLocation();
  const [prevData, setPrevData] = useState([]);
  const getPrevData = async () => {
    try {
      const response = await axios.get(`/api/apply-proc-result/${state.id}`);
      setPrevData(response.data);
    } catch (err) {
      console.log(err);
    }
  };
  const goProcess = () => {
    const id = jwtDecode(sessionStorage.getItem("token")).sub;
    if (id === prevData.applicantId) {
      if (state.menuData.length > 0) {
        let tempObj = {};
        tempObj.id = [state.menuData[0]];
        tempObj.acceptNum = prevData.qualificationNum;
        navigate("/request/institution", { state: tempObj });
      } else {
        Swal.fire({
          icon: "error",
          title: "오류",
          text: "지위승계 신청이 불가합니다. 관리자에 문의해주세요",
          confirmButtonColor: "dodgerBlue",
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "오류",
        text: "로그인계정과 신청계정이 일치하지 않습니다",
        confirmButtonColor: "dodgerBlue",
      });
    }
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
    getPrevData();
  }, [state.id]);
  const CommonTd = ({ title, context }) => {
    return (
      <tbody>
        <tr style={{ height: "45px", wordBreak: "keep-all" }}>
          <td
            width="30%"
            style={{
              backgroundColor: "black",
              color: "white",
              border: "1px solid black",
              borderCollapse: "collapse",
            }}
          >
            <b>{title}</b>
          </td>

          <td
            style={{
              border: "1px solid black",
              borderCollapse: "collapse",
            }}
          >
            {context}
          </td>
        </tr>
      </tbody>
    );
  };
  return (
    <>
      <div className="help_prev">
        <h1>인증정보</h1>

        <div className="help_prev_list_wrap">
          <ul className="help_prev_list">
            <table
              width="100%"
              style={{
                textAlign: "center",
                backgroundColor: "white",
                border: "1px solid black",
                borderCollapse: "collapse",
              }}
            >
              <tbody>
                <tr style={{ height: "55px", wordBreak: "keep-all" }}>
                  <td
                    style={{
                      backgroundColor: "#616B73",
                      color: "white",
                      border: "1px solid black",
                      borderCollapse: "collapse",
                    }}
                    colSpan={2}
                  >
                    주식회사 {prevData.applyProcess?.applicant.companyName}
                  </td>
                </tr>
              </tbody>
              {/* <CommonTd
                title="회사명"
                context={prevData.applyProcess?.applicant.companyName}
              /> */}
              <CommonTd
                title="대표자"
                context={prevData.applyProcess?.applicant.ceoName}
              />
              <CommonTd title="인증번호" context={prevData.qualificationNum} />
              <CommonTd
                title="사업자번호"
                context={prevData.applyProcess?.applicant.companyRegNum}
              />
              <CommonTd
                title="제품명"
                context={prevData.applyProcess?.prdName}
              />
              <CommonTd
                title="모델명"
                context={prevData.applyProcess?.modelName}
              />
              {prevData.state === 8 || prevData.state === 11 ? (
                <CommonTd
                  title="구분"
                  context={
                    prevData.state === 1 ? (
                      <span> 신청완료</span>
                    ) : prevData.state === 2 ? (
                      <span>정기심사완료</span>
                    ) : prevData.state === 3 ? (
                      <span>재평가완료</span>
                    ) : prevData.state === 4 ? (
                      <span> 추가완료</span>
                    ) : prevData.state === 5 ? (
                      <span> 변경완료</span>
                    ) : prevData.state === 6 ? (
                      <span> 재발급완료</span>
                    ) : prevData.state === 8 ? (
                      <span style={{ color: "red" }}>
                        {" "}
                        취소(
                        {prevData?.updateAt
                          .substring(0, 11)
                          .replace(/-/g, ".")
                          .replace(/-/g, ".")}
                        )
                      </span>
                    ) : prevData.state === 11 ? (
                      <span style={{ color: "red" }}>
                        {" "}
                        중지(
                        {prevData?.updateAt
                          .substring(0, 11)
                          .replace(/-/g, ".")
                          .replace(/-/g, ".")}
                        )
                      </span>
                    ) : null
                  }
                />
              ) : null}

              <CommonTd
                title="최초인증일자"
                context={prevData.qualificationDate
                  ?.substring(0, 11)
                  .replace(/-/g, ".")}
              />
              <CommonTd
                title="인증유효기간"
                context={
                  <>
                    {" "}
                    {prevData.qualificationDate
                      ?.substring(0, 11)
                      .replace(/-/g, ".")}
                    ~{prevData.expiredDate?.substring(0, 11).replace(/-/g, ".")}{" "}
                  </>
                }
              />
              <tbody>
                <tr>
                  <td style={{ backgroundColor: "#1e90ff" }} colSpan={2}>
                    <button
                      style={{ width: "100%" }}
                      type="button"
                      className="btn_color"
                      onClick={goProcess}
                    >
                      지위승계 신청
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </ul>

          <ul className="help_prev_list">
            <table
              width="100%"
              style={{
                textAlign: "center",
                backgroundColor: "white",
                border: "1px solid black",
                borderCollapse: "collapse",
              }}
            >
              {prevData.applyProcess?.applyFormValues?.map((e, idx) => {
                return (
                  <tbody key={idx}>
                    <tr style={{ height: "45px", wordBreak: "keep-all" }}>
                      {e.parentItemName === null ? (
                        <td
                          width="30%"
                          style={{
                            flex: "0.1",
                            backgroundColor: "black",
                            color: "white",
                            border: "1px solid black",
                            borderCollapse: "collapse",
                          }}
                        >
                          <b>{e.entryName}</b>
                        </td>
                      ) : (
                        <td
                          width="30%"
                          style={{
                            flex: "0.1",
                            backgroundColor: "black",
                            color: "white",
                            border: "1px solid black",
                            borderCollapse: "collapse",
                          }}
                        >
                          <b>{e.parentItemName}</b>
                        </td>
                      )}
                      <td
                        style={{
                          flex: "0.1",
                          border: "1px solid black",
                          borderCollapse: "collapse",
                        }}
                      >
                        {e.description}
                      </td>
                    </tr>
                  </tbody>
                );
              })}
            </table>
          </ul>
        </div>
      </div>
    </>
  );
}
